import {createSlice} from "@reduxjs/toolkit";

const initialUserGameLeaderboardReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  allPointsCategory: [], 
  allPoints: [], 
  allgameslist: null, 
  gameList: [],
  userLeaderboardreportlist: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const UserGameLeaderboardReportSlice = createSlice({
  
  name: "userGameLeaderboardReport",
  initialState: initialUserGameLeaderboardReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    
    userGameLeaderboardReportList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
       userGameLeaderboardReportExport: (state, action) => {
      const { exportData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.exportData = exportData;
     // state.totalCount = totalCount;
    },
    allPointsCategoryList: (state, action) => {
      const { allPointsCategory } = action.payload;
      state.listLoading = false;
      state.allPointsCategory = allPointsCategory;
    },
    allPointsList: (state, action) => {
      const { allPoints } = action.payload;
      state.listLoading = false;
      state.allPoints = allPoints;
    },
    gamesAllGamesList: (state, action) => {
      const { allgameslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      // state.totalCount = 0;
      state.allgameslist = allgameslist;
    },
    gameList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameList = entities;
    },
  }
});
